import React, { useState } from "react";
import { t } from "i18next";
import DeleteDevice from "./DeleteDevice";
import { DevicesEqTableData } from "../../../../../types/formDataTypes";
import { TbCircleFilled, TbTrash } from "react-icons/tb";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
import { DateTime } from "luxon";

type Props = {
  data: { nodes: DevicesEqTableData[] };
  equipmentId: string;
  updateList: Function;
};

const DevicesTable = ({ data, equipmentId, updateList }: Props) => {
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);
  let [currentItemId, setCurrentItemId] = useState("");

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
    setCurrentItemId("");
  }

  function onItemDelete(id: string): void {
    setCurrentItemId(id);
    openDeleteModal();
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="text-base font-medium">{t('connected_sensors')}</div>
      <Separator className="flex-none"/>
      <div className="flex flex-col gap-2">
      {data.nodes.map(item => (
        <div key={item.id} className="flex flex-col bg-secondary pt-2 pb-4 px-4 rounded text-base gap-2">
          <div className="flex items-center justify-between">
            <div className="flex gap-2 items-center">{item.online ? <><TbCircleFilled size={12} className="text-green-600"/> <span className="text-xs">{t('active')}</span></>: <><TbCircleFilled size={12} className="text-red-600"/><span className="text-xs">{t('no_active')}</span></>}</div>
            <div className="text-xs">{t('connection_date')} {DateTime.fromISO(item.date).toFormat("dd.MM.y")}</div>
          </div>
          <div>
            <div className="grid grid-cols-4">
              <div className="flex flex-col">
                <div className="text-xs">{t('serial_number')}:</div>
                <div className="font-medium leading-4">{item.device_serial_number}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-xs">{t('sensor')}:</div>
                <div className="font-medium leading-4">{item.sensor_type_name}</div>
              </div>
              <div className="flex flex-col">
                <div className="text-xs">{t('idle_level')}:</div>
                <div className="font-medium leading-4">{item.idle_level}</div>
              </div>
              <div className="flex justify-end items-end">
                <Button 
                  type="button" 
                  size={"xs"}
                  onClick={() => onItemDelete(item.id)}
                  variant={"destructive"} 
                  className="flex items-center justify-center w-7 h-7 p-1" 
                ><TbTrash /></Button>
              </div>
            </div>
          </div>
        </div>
      ))}
      </div>
      <DeleteDevice
        sensorId={currentItemId}
        equipmentId={equipmentId}
        isDeleteOpen={isDeleteOpen}
        closeModal={closeDeleteModal}
        updateList={updateList}
      />
    </div>
  );
};

export default DevicesTable;
